<template>
  <div class="mt-12">
    <v-row>
      <v-col><span class="font-weight-bold">Áreas</span></v-col>
    </v-row>
    <div
      v-for="(area, index) in areas"
      :key="area.key"
      :class="{ 'grey lighten-5': index % 2 === 0, small: $vuetify.breakpoint.smAndDown }"
    >
      <v-row class="align-center area-component">
        <v-col md="12">{{ area.name }}</v-col>
        <v-col cols="6" md="8" lg="4" class="d-flex flex-column">
          <div
            class="d-flex align-center gap-2"
            v-for="skinProblem in skinProblemTypes"
            :key="skinProblem.key + area.name"
            :class="{ 'flex-column': $vuetify.breakpoint.smAndDown }"
          >
            <div
              class="d-flex align-center justify-space-between"
              v-if="$vuetify.breakpoint.smAndDown"
              style="width: 100%"
            >
              <span class="text-body-1">{{ skinProblem.name }}</span>
              <span class="text-overline">{{ getSliderLevelText(phaseData[area.key][skinProblem.key]) }}</span>
            </div>
            <span v-if="!$vuetify.breakpoint.smAndDown" class="text-body-1" style="width: 120px">{{
              skinProblem.name
            }}</span>
            <v-slider
              v-model="phaseData[area.key][skinProblem.key]"
              color="primary"
              :max="max"
              :tick-labels="sliderLabels"
              class="mt-4"
              style="max-width: 400px"
              :style="{ width: $vuetify.breakpoint.smAndDown ? '90%' : 'auto' }"
            >
            </v-slider>
            <span v-if="!$vuetify.breakpoint.smAndDown" class="text-overline slider-level">{{
              getSliderLevelText(phaseData[area.key][skinProblem.key])
            }}</span>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="10" lg="6">
          <div class="d-flex align-center justify-space-around text-center">
            <span style="width: 40%">Área acometida</span>
            <span style="width: 40%">Palmas</span>
          </div>
          <div class="d-flex flex-column justify-space-around border rounded-lg">
            <div class="area-box d-flex pa-2 justify-space-around text-center">
              <span style="width: 40%">{{ phaseData[area.key].area }}%</span>
              <v-divider vertical style="color: grey" />
              <span style="width: 40%">{{
                (phaseData[area.key].area * area.factor).toLocaleString()
              }}</span>
            </div>
          </div>
          <div>
            <v-slider v-model="phaseData[area.key].area" color="primary" max="100" class="mt-4" />
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { PUBLIC_STORAGE_URL, PLACEHOLDER_AVATAR_PATH } from '@/constants/global'

export default {
  props: {
    data: Object,
    area: Array,
    types: Array,
    max: Number,
  },
  data() {
    return {
      lazySource: PLACEHOLDER_AVATAR_PATH,
      sliderLabels: [...Array(5).keys()].map((i) => i.toString()),
      skinProblemTypes: this.types,
    }
  },
  computed: {
    areas() {
      return this.area
    },
    phaseData() {
      return this.data
    },
    sliderImages() {
      let types = []
      this.skinProblemTypes.forEach((type) => {
        types.push(type.key)
      })
      const levels = ['leve', 'moderado', 'grave', 'muito-grave']

      const result = {}

      types.forEach(
        (type) => (result[type] = [null, ...levels.map((level) => `${PUBLIC_STORAGE_URL}/${type}-${level}.jpg`)]),
      )

      return result
    },
  },
  methods: {
    getSliderLevelText(level) {
      return ['Ausente', 'Leve', 'Moderada', 'Grave', 'Muito grave'][level]
    },
  },
}
</script>

<style>
.slider-level {
  width: 84px;
  text-align: center;
}
</style>
